import { proxy, subscribe } from 'valtio'
import _ from 'lodash'

const initialTableAttr = {
  tab: 1,
  currentPage: 1,
  pageSize: 10,
  sort: 'created_at:desc',
  refresh: 0,
  filters: {}
}

const storageName = 'weight_based_shipping_rules_table'
let storedTableAttr = { ...initialTableAttr }
if (window.localStorage) {
  let result = JSON.parse(localStorage.getItem(storageName))
  if (!_.isEmpty(result)) {
    console.log(result)
    storedTableAttr = result
  }
}

const tableAttr = proxy({
  state: storedTableAttr,
  reset() {
    tableAttr.state = { ...initialTableAttr }
    localStorage.setItem(storageName, JSON.stringify(initialTableAttr))
  }
})

subscribe(tableAttr, () => {
  console.log('state.arr has changed to', tableAttr.state)
  localStorage.setItem(storageName, JSON.stringify(tableAttr.state))
})

export default tableAttr
